import { Nullable } from '@/utils/types';
import { IAvailabilityIngestion, IListFilters } from '@/bundles/AvailabilityIngestion/types';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export interface IAvailabilityIngestionListing {
  ids: string[];
  loading: boolean;
  error: Nullable<string>;
}

export interface IAvailabilityIngestionStore {
  records: Record<string, IAvailabilityIngestion>;
  listings: Record<string, IAvailabilityIngestionListing>;
}

const initialState: IAvailabilityIngestionStore = {
  records: {},
  listings: {},
};

export function buildListingKey (filter: IListFilters): string {
  return JSON.stringify({
    status: filter.status?.length ? [...filter.status].sort() : null,
    property_id: filter.property_id ?? null,
    limit: filter.limit ?? null,
    offset: filter.offset ?? null,
  });
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
